module.exports = __webpack_public_path__ + "static/media/gymnase_casalis.4a68a07e.jpg";